<template>
  <Drawer
    :title="operateType === 'add' ? '新增Sandbox' : '编辑Sandbox'"
    :visible="visible"
    :before-close="close"
    width="480px"
  >
    <template v-slot:default>
      <el-form ref="form" :model="form" label-width="120px" label-position="top" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input :disabled="operateType === 'add' ? false : true" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Sandbox类型" prop="sandbox_type">
          <el-radio-group
            v-model="form.sandbox_type"
            :disabled="operateType === 'add' ? false : true"
          >
            <el-radio label="full"></el-radio>
            <el-radio label="partial"></el-radio>
            <el-radio label="development"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="应用模版" prop="sandbox_tmpl_id">
          <el-select v-model="form.sandbox_tmpl_id" clearable placeholder="请选择应用模版">
            <el-option
              v-for="item in templateOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            v-model="form.desc"
            :autosize="{ minRows: 10 }"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:footer>
      <el-button class="drawer-footer-btn" type="primary" @click="createSandBox">确定</el-button>
      <el-button class="drawer-footer-btn" @click="cancel">取消</el-button>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/drawer';
import _ from 'lodash';
export default {
  name: 'SandBoxItem',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
  },
  data() {
    return {
      form: {
        name: '',
        sandbox_type: '',
        sandbox_tmpl_id: '',
        desc: '',
      },
      templateOptions: [],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'submit' }],
        sandbox_type: [{ required: true, message: '请选择类型', trigger: 'submit' }],
        sandbox_tmpl_id: [{ required: false, message: '请选择应用模版', trigger: 'submit' }],
      },
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        // this.operateType
        console.log('%c Line:98 🌽 this.operateType', 'color:#465975', this.operateType);
        if (this.operateType === 'add') {
          this.form = {
            name: '',
            sandbox_type: '',
            sandbox_tmpl_id: '',
            desc: '',
          };
          console.log('%c Line:130 🍆 this.form', 'color:#4fff4B', this.form);
        } else {
          this.form = _.cloneDeep(this.row);
          // this.form
          if (this.form.sandbox_tmpl_id == 0) {
            this.form.sandbox_tmpl_id = '';
          }
          if (this.form.sandbox_type === 'partial') {
            this.rules.sandbox_tmpl_id = [
              { required: true, message: '请选择应用模版', trigger: 'submit' },
            ];
            this.$refs.form.clearValidate('sandbox_tmpl_id');
          } else {
            this.rules.sandbox_tmpl_id = [];
          }

          console.log('%c Line:111 🥛 this.form', 'color:#ed9ec7', this.form);
        }
        this.$refs.form.resetFields();
      }
    },
    form: {
      handler(newVal) {
        if (this.operateType === 'add') {
          if (newVal.sandbox_type === 'partial') {
            this.rules.sandbox_tmpl_id = [
              { required: true, message: '请选择应用模版', trigger: 'submit' },
            ];
            // 重新验证 B 字段
            this.$refs.form.validateField('sandbox_tmpl_id');
          } else {
            this.rules.sandbox_tmpl_id = [];
            this.$refs.form.clearValidate('sandbox_tmpl_id');
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getAllSandboxTemplate();
  },
  methods: {
    getAllSandboxTemplate() {
      this.$request({
        url: this.$api.getAllSandboxTemplate,
        data: {},
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.templateOptions = res.list;
      });
    },
    close() {
      this.$emit('close');
    },
    cancel() {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.close();
      });
    },
    createSandBox() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // this.form
          console.log('%c Line:122 🥝 this.form', 'color:#ed9ec7', this.form);
          if (this.operateType === 'add') {
            const params = {
              name: this.form.name,
              sandbox_type: this.form.sandbox_type,
              desc: this.form.desc,
            };
            if (this.form.sandbox_tmpl_id) {
              params.sandbox_tmpl_id = Number(this.form.sandbox_tmpl_id);
            }
            this.$request({
              url: this.$api.createSandbox,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          } else {
            const params = {
              tenant_id: this.form.id,
              desc: this.form.desc,
            };
            if (this.form.sandbox_tmpl_id) {
              params.sandbox_tmpl_id = Number(this.form.sandbox_tmpl_id);
            }
            this.$request({
              url: this.$api.updateSandbox,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          }
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}
</style>
